export default __webpack_public_path__ + "static/media/hero_logo-blue.bf3de368.svg";